import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AcessoApiService } from '../../acessoApi.service';
import { Boleto } from './boleto.model';
import { ExibirMenuService } from '../shared/exibir-menu.service';
import { DadosAcessoService } from '../../dadosAcesso.service';

import { FinanceiroService } from './financeiro.service';

import { BotoesGridRender } from './botoesGrid.component';

declare var $: any;


@Component({
  selector: 'app-financeiro',
  templateUrl: './financeiro.component.html',
  styleUrls: ['./financeiro.component.css']
})
export class FinanceiroComponent implements OnInit {

  public boletos:  any;
  public exibirQuitados: boolean = true;
  public exibirPendentes: boolean = true;
  public selecionadoPendente: string = "active";
  public selecionadoQuitado: string = "active";
  public selecionadoCarta: string = "active";
  public ID_OPER: string;
  public boletosPendentes: Boleto[];
  public boletosQuitados: Boleto[];
  public colDef: any;
  private frameworkComponents;
  private columnDefs2;
  private gridOptions;
  private columnDefs;
  private rowData2;
  private rowData;
  private context;
  public efeito: string = '';
  private localeText;

  constructor(private acessoAPI: AcessoApiService, public exibir: ExibirMenuService, private dadosAcesso: DadosAcessoService,
    private router: Router, private financeiroService: FinanceiroService ) {

    if (sessionStorage.getItem('cod_loja') === null) {

      this.router.navigate(['/']);
    }
    this.columnDefs2 = [
      {headerName: 'Visualizar', field: 'ID_BLTO', cellRenderer:"botoesGridRender", colId: 'ID_BLTO', width: 100, cellClass: 'grid-estilo'},
      {headerName: 'Número', field: 'NUMERO_BLTO', cellClass: 'grid-estilo' },
      {headerName: 'Razão Social', field: 'NOME_PESSOA', cellClass: 'grid-estilo'},
      {headerName: 'Fantasia', field: 'FANTASIA_PESSOA', cellClass: 'grid-estilo'},
      {headerName: 'Vencimento', field: 'VENCTO_BLTO', cellClass: 'grid-estilo'},
      {headerName: 'Valor', field: 'valorConvertido', cellClass: 'grid-estilo'},
      {headerName: '', field: 'LETRA_BLTO', cellClass: 'grid-estilo', width: 10 },
  ];


  this.columnDefs = [
    {headerName: 'Visualizar', field: 'ID_BLTO', cellRenderer:"botoesGridRender", colId: 'ID_BLTO', width: 100, cellClass: 'grid-estilo'},
    {headerName: 'Número', field: 'NUMERO_BLTO', cellClass: 'grid-estilo' },
    {headerName: 'Razão Social', field: 'NOME_PESSOA', cellClass: 'grid-estilo' },
    {headerName: 'Fantasia', field: 'FANTASIA_PESSOA', cellClass: 'grid-estilo'},
    {headerName: 'Pagamento', field: 'PAGTO_BLTO', cellClass: 'grid-estilo'},
    {headerName: 'Valor', field: 'valorConvertido', cellClass: 'grid-estilo'},
    {headerName: '', field: 'LETRA_BLTO', cellClass: 'grid-estilo', width: 10 },
];


  this.rowData2 = this.boletosPendentes;
  this.rowData = this.boletosQuitados;

  this.context = { componentParent: this };

  this.frameworkComponents = {
    botoesGridRender: BotoesGridRender,
  };

  this.gridOptions = {
    rowClass : 'estiloLinha'
  }

  this.localeText = {
    noRowsToShow: "Não há boletos para mostrar",
  }




    //mostrar Rodapé e Menu
    this.exibir.setItensVisiveis(true);

    //recuperar e exibir dados do boleto
    this.ID_OPER = sessionStorage.getItem('id_oper')
    this.acessoAPI.getBoletos(this.ID_OPER).subscribe(res => {
      this.boletos = res;
      this.boletosPendentes = this.boletos;
      this.rowData2 = this.boletosPendentes;

    } );

    this.acessoAPI.getBoletosQuitados(this.ID_OPER).subscribe(res => {
      this.boletos = res;
      this.boletosQuitados = this.boletos;

      this.rowData = this.boletosQuitados;

    });
  }

  ngOnInit() {
    $(document).ready(function() {
      // $("#saida").hide();
      $('#Quitados').click(function() {
          $('#saida').slideToggle(800);
      });
  });

  $(document).ready(function() {
    $('#Pendentes').click(function() {
        $('#saida2').slideToggle(800);
    });
});


}

  exibeQuitados(): void {
    if (this.exibirQuitados === true) {
      this.exibirQuitados = false;
      this.selecionadoQuitado = '';

    }else {
      this.exibirQuitados = true;
      this.selecionadoQuitado = 'active';
    }

  }
 exibePendentes(): void{

    if(this.exibirPendentes === false){
      this.exibirPendentes = true
      this.selecionadoPendente = "active";
    }else {
      this.exibirPendentes = false;
      this.selecionadoPendente = '';
    }
  }

  // ExportarBoleto(){
  //   const elementToPrint = document.getElementById('BoletoImpressao');
  //   const pdf = new jsPDF('p', 'pt', 'a4');
  //   pdf.addHTML(elementToPrint, () => {
  //     pdf.save('boleto.pdf');
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/app/pages/financeiro/financeiro.component.ts